import { IonIcon } from "@ionic/react";

interface Props {
  label: string;
  iconLeft?: string;
  iconRight?: string;
  isDisabled?: boolean;
  isDisplayed?: boolean;
  onClick: () => void;
}

const ButtonSlide: React.FC<Props> = ({
  label,
  iconLeft,
  iconRight,
  isDisabled = false,
  isDisplayed = true,
  onClick,
}) => {
  return (
    <>
      {isDisplayed && (
        <button
        style={{
          backgroundColor : "#FF6214",
          borderRadius : "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "5px 10px",
          margin: "10px",
          fontSize: "1em",
          color: "white",
          cursor: "pointer",
        }}
          disabled={isDisabled}
          onClick={onClick}
          color="darkOrange"
        >
          {iconLeft && <IonIcon icon={iconLeft} slot="start" size="large" />}
          {label}
          {iconRight && <IonIcon icon={iconRight} slot="end" size="large" />}
        </button>
      )}
    </>
  );
};

export default ButtonSlide;
